import React, { Component } from 'react'

class ToastElement extends Component {
  render() {
    let {alert} = this.props;
    return (
      <span id={alert.key}><a href={alert.link} alt={alert.key}>{alert.text}</a></span>
    )
  }
}

export default ToastElement


// WEBPACK FOOTER //
// ./src/components/Header/_ToastElement.js